import { Grid } from '@mui/material';
import AuthorCreateFormView from '../../../components/application/create/author/AuthorCreateFormView';
import AuthorTableListView from '../../../components/application/create/author/AuthorTableListView';
import useFetchData from '../../../helpers/useFetch';
import AppURL from '../../../constants/AppURL';
import { useState } from 'react';

const AppAuthorAddListView = () => {
    const [onURL, setOnURL] = useState(AppURL.ApplicationURL + 'app/author/list/view/');
    const { data, loading, error, refetch } = useFetchData(onURL);

    const handleFormSuccess = ():void => {
        refetch(); // Recall the API to fetch the latest data
    };
   
  return (
    <Grid container spacing={3}>
        <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
            <AuthorCreateFormView handleFormSuccess={handleFormSuccess} />
        </Grid>
        <Grid item xl={6} md={6} sm={12} xs={12} lg={6}>
            <AuthorTableListView setOnURL={setOnURL} data={data} error={error} loading={loading} />
        </Grid>
    </Grid>
  )
}

export default AppAuthorAddListView